<template>
	<div class="page-child">
		<div class="left-container">
			<table-list
        ref="tableList"
        v-show="showTable"
        @to-add="handleToAdd"
        @to-edit="handleToEdit"
        :factoryLangId="initialData.businessLangId"
        :lang="initialData.lang"
      />

			<!-- 表单组件：默认隐藏 -->

		<!-- :factoryLangId="initialData.businessLangId" -->

			<form-page
        ref="formPage"
        v-show="!showTable"
        :form-data="editData"
        :initial-data="initialData"
        :if-fac-or-br="ifFacOrBr"
        @back="handleBack"
      />
		</div>
	</div>
</template>

<script>
	// Vue2 引入组件
	import TableList from '../mainChild/TableList.vue'
	import FormPage from '../mainChild/FormPage.vue'

	export default {
		// 注册组件
		components: {
			TableList,
			FormPage
		},
		props: {
			ifFacOrBr: {
				type: String,
				default: ""
			},
			initialData: Object
		},
		data() {
			return {
				// 控制切换：true=显示表格，false=显示表单
				showTable: true,
				// 编辑时的行数据
				editData: {}
			}
		},

		methods: {
			// 切 Tab 离开时：回到列表视图
			resetData() {
			  this.showTable = true
			},
			// 点击新增
			handleToAdd() {
				this.editData = {} // 清空数据
				this.showTable = false
				this.$emit('view-change', false)
			},

			// 点击编辑
			handleToEdit(row) {
				this.editData = {
					...row
				} // 传递当前行数据
				this.showTable = false
				this.$emit('view-change', false)
			},

			// 表单返回
			handleBack() {
				this.showTable = true
				this.$emit('view-change', true)
				this.$emit('dirty', false)
				setTimeout(() => {
					const tl = this.$refs.tableList;
					if (tl) {
						tl.getData(tl.pageInfo ? tl.pageInfo.current : 1);
					}
				}, 100)
			},
	}
	}
</script>

<style scoped>
	.page-child {
		display: flex;
		gap: 20px;
		margin-top: 20px;
	}

	/* .left-container {
  width: 60%;
  border: 1px solid #eee;
  padding: 16px;
} */
	.left-container {
  flex: 1;
  min-width: 0;
}
	.right-tab {
		width: 40%;
		border: 1px solid #eee;
		padding: 16px;
	}
</style>
